import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { Team as Desc } from './desk'
import { Team as Mob } from './mob'

type Props = {
  images: TImages
}
export const Team: React.FC<Props> = ({ images }) => {
  const { isMobile } = useDimensions()
  return isMobile ? <Mob images={images} /> : <Desc images={images} />
}
